<template>
  <component
    :is="type"
    v-clipboard:copy="copy"
    v-clipboard:success="onCopySuccess"
    v-clipboard:error="onError"
    type="text"
    :class="type === 'i' ? 'el-icon-document-copy' : ''"
    >{{ type === 'el-button' ? $t('copyText') : '' }}</component
  >
</template>

<script>
export default {
  name: 'BjCopyIcon',
  props: {
    type: {
      type: String,
      default: 'i',
      validator: function(value) {
        return ['i', 'el-button'];
      },
    },
    copy: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    onCopySuccess() {
      this.$message.success(this.$t('ReplicationSucceededText'));
    },
    onError() {}
  }
};
</script>

<style></style>
